(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    ngModule.controller('OrderCtrl', function TodoCtrl($scope, $Orders) {
        $scope.data = $Orders.all();
    });

})();
